import React, { Component } from 'react';
import moment from 'moment';
import Tablec from 'components/Tablec';
import Inputc from 'components/Inputc';
import './index.styl';

const clzpre = 'dsh-realname-table';

const timeRender = value => {
    if (!value) {
        return '';
    }
    const time = moment(value);
    const str = time.format('hh:mm');
    const h = parseInt(time.format('HH'));
    return `${h > 12 ? '下午' : '上午'} ${str}`;
};

const columns = [
    {
        name: '姓名',
        key: 'name'
    },
    {
        name: '籍贯',
        key: 'hometown'
    },
    {
        name: '年龄',
        key: 'age',
        render: v => {
            const age = v > 18 && v < 70 ? v : '';
            return <span>{age}</span>;
        }
    },
    {
        name: '上班时间',
        key: 'goToWork',
        render: timeRender
    },
    {
        name: '下班时间',
        key: 'goOffWork',
        render: timeRender
    }
];

class TableView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    filterData = tds => {
        const { value } = this.state;
        if (!value) {
            return tds;
        }
        return tds.filter(d => {
            let flag = false;
            for (let k in d) {
                if (d[k] && d[k].toString().indexOf(value) > -1) {
                    flag = true;
                    break;
                }
            }
            return flag;
        });
    };

    onKeyDown = e => {
        if (e.keyCode === 13) {
            this.setState({
                value: e.target.value
            });
        }
    };

    render() {
        const { data } = this.props;
        const props = { columns, data, autoScroll: true };
        return (
            <div className={clzpre}>
                <p>
                    <Inputc.Search placeholder="请输入" onKeyDown={this.onKeyDown} />
                </p>
                <div>
                    <Tablec {...props} filter={this.filterData} />
                </div>
            </div>
        );
    }
}

export default TableView;
